import { render } from "./BaseContainer.vue?vue&type=template&id=4a0eeb33&scoped=true"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=4a0eeb33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0eeb33"]])

export default __exports__